import { render } from "./salary_admin.vue?vue&type=template&id=6c26b1dc"
import script from "./salary_admin.vue?vue&type=script&lang=js"
export * from "./salary_admin.vue?vue&type=script&lang=js"

import "./salary_admin.vue?vue&type=style&index=0&id=6c26b1dc&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__